import { render, staticRenderFns } from "./sales_transparent_pricing.vue?vue&type=template&id=37615c4c&"
import script from "./sales_transparent_pricing.vue?vue&type=script&lang=js&"
export * from "./sales_transparent_pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports